'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _lodash = require('lodash');

var _utility = require('./utility');

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _RUMUtil = require('../utils/RUMUtil');

var _RUMUtil2 = _interopRequireDefault(_RUMUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-unused-expressions */


// videoLibrary can be overriden with a custom JS video library, if desired
// this also makes testing/mocking easier:

var MicrosoftECDNVideoPlayer = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(videoId, config) {
    var videoLibrary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _video2.default;

    var dmInstance, player, PLUGIN_VERSION, PLATFORM_NAME, microsoftTenantId, userId, eventId, localIp, _window, peer5, urls, setSourceList;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setSourceList = function setSourceList(urls) {
              if (!Array.isArray(urls) || (0, _lodash.isEmpty)(urls)) {
                console.warn('[MicrosoftECDNVideoPlayer] Invalid URLs supplied to the video player.');
                return false;
              }
              var urlList = (0, _utility.processUrls)(urls, config);
              player.src(urlList);
              dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[MicrosoftECDNVideoPlayer] source urls: ', urls);
              return true;
            };

            dmInstance = _DebugManager2.default.dmInstance;

            window.videojs = _video2.default;
            player = void 0;
            _context.prev = 4;
            PLUGIN_VERSION = 'v1';
            PLATFORM_NAME = 'mediaplatform';
            microsoftTenantId = config.microsoftTenantId, userId = config.userId, eventId = config.eventId, localIp = config.ipAddress.internalIpAddress;

            if (window.peer5) {
              _context.next = 13;
              break;
            }

            _context.next = 11;
            return (0, _utility.loadScript)('//sdk.ecdn.microsoft.com/peer5.js?id=' + microsoftTenantId);

          case 11:
            _context.next = 13;
            return (0, _utility.loadScript)('//sdk.ecdn.microsoft.com/peer5.' + PLATFORM_NAME + '.' + PLUGIN_VERSION + '.plugin.js');

          case 13:
            _window = window, peer5 = _window.peer5;


            peer5 && peer5.configure({ streamingPlatformUserId: userId || 'guest-' + Math.random().toString(36).slice(-8) });
            peer5 && peer5.configure({ streamingPlatformEventId: 'MP:' + eventId });
            peer5 && peer5.configure({ localIp: localIp || '' });

            dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[MicrosoftECDNVideoPlayer] sending configuration: ', config);
            dmInstance.log('[MicrosoftECDNVideoPlayer] videojs version: ', _video2.default.VERSION);

            player = videoLibrary(videoId, config);
            (0, _utility.setupHooks)(player, config);
            urls = config.urls;

            setSourceList(urls);
            return _context.abrupt('return', Promise.resolve(player));

          case 26:
            _context.prev = 26;
            _context.t0 = _context['catch'](4);

            _RUMUtil2.default.addError(_context.t0);
            console.warn('Problem loading Microsoft eCDN. Falling back to default distribution');

          case 30:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[4, 26]]);
  }));

  return function MicrosoftECDNVideoPlayer(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = MicrosoftECDNVideoPlayer;